import { render, staticRenderFns } from "./scrap.vue?vue&type=template&id=5d95b48d&scoped=true"
import script from "./scrap.vue?vue&type=script&lang=js"
export * from "./scrap.vue?vue&type=script&lang=js"
import style0 from "./scrap.vue?vue&type=style&index=0&id=5d95b48d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d95b48d",
  null
  
)

export default component.exports